export const UPLOAD_FILE = 'UPLOAD_FILE';
export const GET_FILE_LIST = 'GET_FILE_LIST';
export const DELETE_FILE_BY_FILENAME = 'DELETE_FILE_BY_FILENAME';
export const GET_FILE_INFO = 'GET_FILE_INFO';
export const FILE_UPDATE_BY_KEY = 'FILE_UPDATE_BY_KEY';